import { http } from '@/app/lib/http/client'
import { ListParams, PaginatedResponse } from '../types/pagination'

// ─── Tipos de movimiento ──────────────────────────────────────────────────────

export type InventoryTransferType =
  | 'transfer_sent'                   // Transferencia enviada
  | 'transfer_requested'              // Transferencia solicitada
  | 'transfer_received'               // Transferencia recibida

//-----------------------------Tipos de movimiento de transferencia -------------

//Transferencia enviada - Puede derivarse de una solicitud o no.
export interface InventoryTransfer {
  id: number
  transfer_request_id: number
  origin_sucursal_id: number
  destination_sucursal_id: number
  sent_by_user_id: number | null
  notes?: string
  status: string
  sent_at: string
  received_at?: string
}

//Transferencia solicitada - No se ha enviado
export interface InventoryTransferRequest {
  id: number
  requested_by_user_id: number | null
  origin_sucursal_id: number
  destination_sucursal_id: number
  notes?: string
  status: string
  requested_at: string
  reviewed_at?: string
}

//Transferencia recibida
export interface InventoryTransferReceipt {
  id: number
  inventory_trasfer_id: number
  received_by_user_id: number | null
  received_at?: string
  notes?: string
}

// ─── Filtros ──────────────────────────────────────────────────────────────────

export interface InventoryTransferFilters extends ListParams {
  sucursal_id?: number
  origin_sucursal_id?: number
  destination_sucursal_id?: number
  type?: InventoryTransferType | ''
  /** Fecha inicio ISO YYYY-MM-DD */
  from?: string
  /** Fecha fin ISO YYYY-MM-DD */
  to?: string
  search?: string
}

// ─── Servicio ─────────────────────────────────────────────────────────────────

export const inventoryTransfersService = {
  async getTransfers(
    params?: InventoryTransferFilters
  ): Promise<PaginatedResponse<InventoryTransfer>> {
    const response = await http.get('/inventory-transfers', { params })
    const d = response.data
    // Normaliza estructura anidada estilo Laravel
    if (d?.data?.data && Array.isArray(d.data.data)) return d.data
    if (d?.data && Array.isArray(d.data)) return d
    return d
  },

  async getTransferRequests(
    params?: InventoryTransferFilters
  ): Promise<PaginatedResponse<InventoryTransferRequest>> {
    const response = await http.get('/transfer-requests', { params })
    const d = response.data
    // Normaliza estructura anidada estilo Laravel
    if (d?.data?.data && Array.isArray(d.data.data)) return d.data
    if (d?.data && Array.isArray(d.data)) return d
    return d
  },
}
